import { ResultadoArquivamento } from "./ResultadoArquivamento";

export default ResultadoArquivamento;